import { makeStyles } from "tss-react/mui";

import { Box, Theme } from "@mui/material";
import { TextLink } from "@shared/TextLink";

const useStyles = makeStyles({ name: "HelpLinkBar" })((theme: Theme) => ({
    bar: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: theme.spacing(1),
        width: "100%",
        minWidth: 0,
        flexShrink: 0,
        marginBottom: theme.spacing(2),
    },
}));

type HelpLinkBarProps = {
    label: string;
    tooltip: string;
    onClick: () => void;
    className?: string;
};

export function HelpLinkBar(props: HelpLinkBarProps) {
    const { classes, cx } = useStyles();

    return (
        <Box className={cx(classes.bar, props.className)}>
            <i className="fa-solid fa-circle-info" aria-hidden />
            <TextLink variant="body1" component="button" type="button" onClick={props.onClick} tooltip={props.tooltip}>
                {props.label}
            </TextLink>
        </Box>
    );
}
